import type { CheckoutSession, PaymentOption } from "@/types";
import type { MoneyAmount as Money } from "@/shared/types/payment";

const hasPositiveAmount = (m?: Money | null): m is Money =>
  !!m && typeof m.amount === "number" && m.amount > 0;

/**
 * Resolves wallet / due-today values for the read-only plan summary breakdown.
 * Wallet rows are shown only when the user has the wallet toggle ON — session
 * fields like walletDownPaymentAmount are always populated when a balance
 * exists, regardless of toggle state.
 */
export function resolvePlanAmountBreakdown(
  session: CheckoutSession,
  option: PaymentOption,
  isWalletSelected: boolean,
): {
  walletDiscount?: Money;
  dueToday: Money;
} {
  const walletDiscount =
    isWalletSelected && hasPositiveAmount(session.paymentDetails?.walletDownPaymentAmount)
      ? session.paymentDetails!.walletDownPaymentAmount!
      : undefined;

  const dueToday =
    isWalletSelected && session.paymentDetails?.cardDownPaymentAmountWithWallet
      ? session.paymentDetails.cardDownPaymentAmountWithWallet
      : option.downPaymentAmount;

  return { walletDiscount, dueToday };
}
